import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CloseDialog, OpenDialog, OpenUrl } from './error.actions';
import { ErrorDialogState } from './error.state';

@Injectable({
  providedIn: 'root'
})
export class ErrorDialogFacade {
  private readonly store = inject(Store);

  @Select(ErrorDialogState.open) open$: Observable<boolean>;
  @Select(ErrorDialogState.url) url$: Observable<string>;
  @Select(ErrorDialogState.content) content$: Observable<string>;

  openDialog(url: string, content: string) {
    this.store.dispatch(new OpenDialog(url, content));
  }

  closeDialog() {
    this.store.dispatch(new CloseDialog());
  }

  openUrl() {
    this.store.dispatch(new OpenUrl());
  }
}
